import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import {
  Card,
  Typography,
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  FormControl,
  Select,
  MenuItem,
  Tooltip,
  Button,
  Box,
  InputLabel,
  TextField,
  Modal,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import dayjs from "dayjs";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../assets/css/Datatable.css";
import { FaSearch } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import SwapVertSharpIcon from "@mui/icons-material/SwapVertSharp";
import { InputText } from "primereact/inputtext";
import Profile from "./Profile";

function DataFileStatus() {
  const [feedDetails, setFeedDetails] = useState([]);
  const [datesChecked, setDatesChecked] = useState([]);
  const [viewMode, setViewMode] = useState("curation");
  const [frequency, setFrequency] = useState("daily");
  const [sources, setSources] = useState([]);
  const [selectedFeed, setSelectedFeed] = useState(null);
  const [errors, setErrors] = useState({});
  const [username, setUsername] = useState(localStorage.getItem("username"));
  const [tableData, setTableData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [dataArrivalStatus, setDataArrivalStatus] = useState("");
  const [dataArrivalTime, setDataArrivalTime] = useState("");
  const [isRowEdited, setIsRowEdited] = useState(false);
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);
  const [areFiltersEnabled, setAreFiltersEnabled] = useState(false);
  const [filters, setFilters] = useState(null);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(1);
  const [selectedRecord, setSelectedRecord] = useState([]);
  const [openEdit, setOpenEdit] = useState(false);
  const [exportData, setExportData] = useState(null);
  const [isEditingEnabled, setIsEditingEnabled] = useState(false);
  const [isDuplicateCountChanged, setIsDuplicateCountChanged] = useState(false);
  const [duplicateselect, setDuplicateselect] = useState(false)
  const [bulkeditdata, setbulkeditdata] = useState({
    arrival_time: "",
    data_arrived: "",
  });
  const [value, setValue] = useState(null);
  const [openBulkEdit, setOpenBulkEdit] = useState(false);
  const [openConfirmSave, setOpenConfirmSave] = useState(false);
  const [disableReset, setDisableReset] = useState(false);
  const [editElement, setEditElement] = useState([]);
  const [saveState, setSaveState] = useState(false)
  const [error, setError] = useState(false); // Boolean state for error
  const [arrivalDateError, setArrivalDateError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const [helperArrivalText, setHelperArrivalText] = useState(""); // State for error message
  // Get today's date in yyyy-mm-dd format
  const getTodayDate = () => dayjs().format("YYYY-MM-DD");
  const navigate = useNavigate();

  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [name, value] = cookie.split("=");
    acc[name] = decodeURIComponent(value);
    return acc;
  }, {});
  useEffect(() => {
    const ifAnyChanged = selectedRecord?.some((item) =>
      item.data_arrived !== "NOT ARRIVED" ||
      (item.arrival_time !== "" && item.arrival_time !== null) ||
      item.duplicate_count !== 0 // Added this condition for duplicate_count
    );

    if (ifAnyChanged) {
      setDisableReset(true);
    } else {
      setDisableReset(false);
    }

    // Optionally, handle the case when selectedRecord is empty
    // if (selectedRecord.length === 0) {
    //   console.log("true", disableReset);
    // }
  }, [selectedRecord]);

  useEffect(() => {
    // Scroll to the top of the page on component mount
    window.scrollTo(0, 0);
  }, []); // Empty dependency array to only run on component mount
  useEffect(() => {
    setFilters({
      source_name: { value: null, matchMode: "contains" },
      source_table: { value: null, matchMode: "contains" },
      frequency: { value: null, matchMode: "contains" },
      expected_time: { value: null, matchMode: "contains" },
      duplicate_count: { value: null, matchMode: "contains" },
      arrival_date: { value: null, matchMode: "contains" },
      arrival_time: { value: null, matchMode: "contains" },
      data_arrived: { value: null, matchMode: "contains" },
      validated_by: { value: null, matchMode: "contains" },
      global: { value: null, matchMode: "contains" },
    });
  }, []);
  const fetchSources = async () => {
    try {
      const apiUrl = `/get-distinct-feed-names/?frequency=${frequency}`;
      const response = await axios.get(apiUrl);
      setSources(response.data);
    } catch (error) {
      console.error("Error fetching sources:", error);
    }
  };
  const fetchFeedDetails = async (feedName) => {
    try {
      const apiUrl = `/get-source-details/?source_name=${feedName}&frequency=${frequency}`;
      const response = await axios.get(apiUrl);


      console.log(response?.data, "response");
      setFeedDetails(response?.data?.data);
      setDatesChecked(response?.data?.dates_checked)
    } catch (error) {
      console.error("Error fetching feed details:", error);
    }
  };
  console.log(datesChecked, "dates checked");

  const handleBulkEdit = () => {
    setError(false);
    setArrivalDateError(false);
    setHelperArrivalText("")
    setHelperText("");
    setOpenBulkEdit(!openBulkEdit);
  };
  // Enable or disable the Save button based on whether there are unsaved changes
  useEffect(() => {
    if ((dataArrivalStatus && dataArrivalTime) || isRowEdited) {
      setIsSubmitEnabled(true);
    } else {
      setIsSubmitEnabled(false);
    }
  }, [dataArrivalStatus, dataArrivalTime, isRowEdited]);

  useEffect(() => {
    if (Array.isArray(feedDetails) && feedDetails.length > 0) {
      const updatedData = feedDetails.map((row) => ({
        ...row,
        arrival_date: row?.arrivalDate || getTodayDate(), // Set default date as today's date
        arrival_time: row.arrival_time || "", // Default empty time
      }));
      setTableData(updatedData);

      setSelectedRows([]);
      setDataArrivalStatus("");
      setDataArrivalTime("");
      setIsRowEdited(false);
    }
  }, [feedDetails]);
  console.log(feedDetails, "feed details");

  const sortDataBySourceName = () => {
    const sortedData = [...tableData].sort((a, b) => {
      const nameA = a.source_name.toLowerCase();
      const nameB = b.source_name.toLowerCase();

      if (nameA < nameB) return sortOrder; // Ascending or descending based on sortOrder
      if (nameA > nameB) return -sortOrder;
      return 0;
    });

    setTableData(sortedData); // Update the state with sorted data
    setSortOrder(sortOrder === 1 ? -1 : 1); // Toggle sortOrder for the next click
  };
  const handleFieldChange = (id, field, value) => {
    setTableData((prev) => {
      const updatedRows = prev.map((row) =>
        row.id === id ? { ...row, [field]: value } : row
      );
      return updatedRows;
    });
    setIsRowEdited(true);
    setIsSubmitEnabled(true);
  };
  const onSubmit = async (updatedData) => {
    setSaveState(true)
    try {
      const dataToSend = Array.isArray(updatedData)
        ? updatedData
        : [updatedData];

      const dataWithValidator = dataToSend.map((row) => ({
        ...row,
        validated_by: username,
      }));

      const headers = {
        "Content-Type": "application/json",
        "X-CSRFToken": cookies.csrftoken,
      };

      await axios.post("/insert-source-details/", dataWithValidator, { headers });
      showToast();

      setTimeout(() => {
        navigate("/");
        setSaveState(false)
      }, 2000);


    } catch (error) {
      console.error("Error submitting data:", error);
    }
    setOpenConfirmSave(false)
    setOpenEdit(false);
    setOpenBulkEdit(false);
  };
  const handleReset = () => {
    const resetFields = (item) => ({
      ...item,
      arrival_time: null,
      data_arrived: "NOT ARRIVED",
      duplicate_count: 0
    });

    if (selectedRecord && selectedRecord.length > 0) {
      // First, update all selectedRecord values
      const updatedSelectedRecord = selectedRecord.map(resetFields);

      // Now update the tableData based on the updated selectedRecord
      setTableData((prevTableData) =>
        prevTableData.map((item) => {
          // Check if the item is in the updated selected records, then update
          const foundItem = updatedSelectedRecord.find(
            (selected) => selected.id === item.id // Assuming `id` is the unique identifier
          );
          return foundItem ? foundItem : item; // If found, replace with updated; otherwise, keep the original
        })
      );

      // Set the updated selected records to the state
      setSelectedRecord(updatedSelectedRecord);
    } else {
      // Reset all records in tableData if no specific selection
      setTableData((prevTableData) => prevTableData.map(resetFields));
    }
    setSelectedRecord([]);
    setDisableReset(false);
  };

  console.log(editElement.arrival_date, "arrival date");


  const handleSubmit = () => {
    if (
      editElement.data_arrived !== "NOT ARRIVED" &&
      (!editElement.arrival_time || editElement.arrival_time === "")
    ) {
      setError(true); // Set error to true
      setHelperText("Please set an arrival time");
      if (
        editElement.data_arrived !== "NOT ARRIVED" &&
        (datesChecked && !editElement.arrival_date)
      ) {
        setArrivalDateError(true); // Set error to true
        setHelperArrivalText("Please set an arrival date"); // Set the error message
        return; // Exit without submitting
      }
      return; // Exit without submitting
    }
    if (
      editElement.data_arrived !== "NOT ARRIVED" &&
      (datesChecked && !editElement.arrival_date)
    ) {
      setArrivalDateError(true); // Set error to true
      setHelperArrivalText("Please set an arrival date"); // Set the error message
      return; // Exit without submitting
    }
    if (
      editElement.data_arrived !== "NOT ARRIVED" &&
      (editElement.arrival_time !== "" && editElement.arrival_time !== null)
    ) {
      setDisableReset(true);


      setSelectedRecord(
        selectedRecord.map((item) => {
          return {
            ...item,
            arrival_time: editElement.arrival_time,
            data_arrived: editElement.data_arrived,
            arrival_date: frequency !== "Ad-Hoc" ? (editElement?.arrival_date || datesChecked?.[0] || getTodayDate()) : getTodayDate()
          };
        })
      );
      setTableData((prev) => {
        const updatedData = prev.map((row) => {
          if (selectedRecord.some((user) => user.id === row.id)) {
            const finalUpdate = {
              ...row,
              arrival_time: editElement.arrival_time,
              data_arrived: editElement.data_arrived,
              arrival_date: frequency !== "Ad-Hoc" ? (editElement?.arrival_date || datesChecked?.[0] || getTodayDate()) : getTodayDate()
            };
            return finalUpdate;
          }
          return row;
        });
        // onSubmit(updatedData); // Send the updated table data
        return updatedData; // Update state with new data
      });
      setOpenEdit(false);
      setOpenBulkEdit(false);
      setSelectedRecord([]);
    }
    if (
      editElement.data_arrived === "NOT ARRIVED"
    ) {
      setDisableReset(true);


      setSelectedRecord(
        selectedRecord.map((item) => {
          return {
            ...item,
            arrival_time: editElement.arrival_time,
            data_arrived: editElement.data_arrived,
            arrival_date: frequency !== "Ad-Hoc" ? (editElement?.arrival_date || datesChecked?.[0] || getTodayDate()) : getTodayDate()
          };
        })
      );
      setTableData((prev) => {
        const updatedData = prev.map((row) => {
          if (selectedRecord.some((user) => user.id === row.id)) {
            const finalUpdate = {
              ...row,
              arrival_time: editElement.arrival_time,
              data_arrived: editElement.data_arrived,
              arrival_date: frequency !== "Ad-Hoc" ? (editElement?.arrival_date || datesChecked?.[0] || getTodayDate()) : getTodayDate()
            };
            return finalUpdate;
          }
          return row;
        });
        // onSubmit(updatedData); // Send the updated table data
        return updatedData; // Update state with new data
      });
      setOpenEdit(false);
      setOpenBulkEdit(false);
      setSelectedRecord([]);
    }
  };
  const [openDialog, setOpenDialog] = useState(false);
  const showToast = () => {
    toast.success("Data inserted successfully!", {
      duration: 2000,
      position: "top-right",
    });
  };
  const data = feedDetails;
  useEffect(() => {
    if (selectedFeed) {
      fetchFeedDetails(selectedFeed);
    }
    // setSelectedRecord();
  }, [selectedFeed]);
  useEffect(() => {
    if (datesChecked) {
      editElement.arrival_date = datesChecked?.[0]
    }
  }, [datesChecked])

  const handleEdit = (e) => {
    if (selectedRecord && selectedRecord.length > 0) {
      setEditElement(selectedRecord[0]);
    } else {
      console.log("No user selected");
    }
    const handleBulkEdit = () => {
      setError(false);
      setHelperText("");
      setOpenBulkEdit(!openBulkEdit);
    };
    setOpenEdit(!openEdit);
  };
  useEffect(() => {
    fetchSources();
    setSelectedRecord([]);
  }, [frequency]);
  let mergedSelection = selectedFeed
    ? `${frequency.toUpperCase()} / ${selectedFeed}`
    : "";
  const handleSourceChange = (event) => {
    const selected = event.target.value;
    if (selected !== "") {
      console.log(selected, "-------------------sele---------------")
      setSelectedFeed(selected);
      setSelectedRecord([]);
    }
    else {
      setTableData([]);
      setSelectedFeed()
    }

  };
  const handleFrequencyChange = (event) => {
    setFrequency(event.target.value);
    setSelectedFeed(null);
    setTableData([]);
  };
  const navigateToTodayRecords = () => {
    navigate("/"); // Index of the "Today's Records" tab
  };
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;
    setFilters(_filters);
  };
  const toggleFilters = () => {
    setAreFiltersEnabled(!areFiltersEnabled);
  };
  const updateTableDataForSelectedRows = (field, value) => {
    setTableData((prev) =>
      prev.map((row, index) => {
        if (selectedRows.includes(index)) {
          return { ...row, [field]: value || row[field] };
        }
        return row;
      })
    );
  };
  const getFrequencyStyle = (value) => {
    switch (value) {
      case 'DAILY':
        return { background: "#007bff20", color: '#007bff', padding: '0.2rem 1.5rem', borderRadius: '25px' };
      case 'WEEKLY':
        return { backgroundColor: '#28a74520', color: '#28a745', padding: '0.2rem 1.3rem', borderRadius: '25px' };
      case 'MONTHLY':
        return { backgroundColor: '#dffa7c63', color: '#dab326', padding: '0.2rem 0.5rem', borderRadius: '25px' };
      case 'QUARTERLY':
        return { backgroundColor: '#fde5cd', color: '#f08a2c', padding: '0.2rem 0.5rem', borderRadius: '25px' };
      default:
        return { backgroundColor: '#e4dbee', color: '#7339bb', padding: '0.2rem 1.1rem', borderRadius: '25px' };
    }
  };
  const statusBodyTemplate = (rowData) => {
    const style = getFrequencyStyle(rowData.frequency);
    return <span style={style}>{rowData.frequency}</span>;
  };
  const handleDataArrivalStatusChange = (event) => {
    const status = event.target.value;
    setEditElement((prev) => ({ ...prev, data_arrived: status }));

    // setDisableReset(true)
    // setDataArrivalStatus(status);
    // updateTableDataForSelectedRows("data_arrived", status);
  };

  const handleArrivalDateChange = (event) => {
    setArrivalDateError(false)
    setHelperArrivalText("")
    console.log(event.target.value, "value");
    const date = event.target.value
    setEditElement((prev) => ({ ...prev, arrival_date: date }));

  }
  const handleDataArrivalTimeChange = (event) => {
    setError(false)
    setHelperText('')
    const time = event.target.value;
    setEditElement((prev) => ({ ...prev, arrival_time: time }));
    setEditElement((prev) => ({ ...prev, arrival_time: time }));
    // setDisableReset(true)
    // setDataArrivalTime(time);
    // updateTableDataForSelectedRows("arrival_time", time);
  };
  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(
        selectedRecord && selectedRecord.length > 0 ? selectedRecord : tableData
      );
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "Products");
    });
  };
  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(data, fileName + "Record" + EXCEL_EXTENSION);
      }
    });
  };
  const dataTableHeader = (
    <div
      className="table-header align-items-center"
      style={{ display: "flex" }}
    >
      <span
        className="p-input-icon-left ms-1"
        style={{ justifyContent: "flex-start" }}
      >
        <FaSearch className="p-icon" />
        <InputText
          className="input py-1"
          type="search"
          onInput={onGlobalFilterChange}
          placeholder="Search"
        />
      </span>

      <div
        style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}
      >
        <Button
          variant="text"
          className="btn-sm ms-1 py-1"
          style={{
            color: "#333",
            fontSize: "15px",
            fontWeight: 500,
            marginRight: "10px",
          }}
          onClick={toggleFilters}
        >
          <FilterAltOutlinedIcon />
          Filter
        </Button>
        <Button
          variant="text"
          className="btn-sm ms-1 py-1"
          style={{
            color: "#333",
            fontSize: "15px",
            fontWeight: 500,
            marginRight: "10px",
          }}
          onClick={sortDataBySourceName}
        >
          <SwapVertSharpIcon />
          Sort
        </Button>
      </div>
    </div>
  );
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 550,
    maxWidth: openConfirmSave ? "fit-content" : "25rem",
    bgcolor: "background.paper",

    boxShadow: 24,
    p: 0,
    borderRadius: "12px",
  };
  const onCellEditComplete = (e) => {
    const { rowData, newValue, field } = e;
    let updatedTableData = [...tableData];
    const index = updatedTableData.findIndex((item) => item.id === rowData.id);

    if (index !== -1) {
      updatedTableData[index][field] = newValue; // Update the specific field with the new value
      setTableData(updatedTableData); // Set the updated data
    }
  };
  const handleNoDuplicateChange = (e, rowData) => {
    const updatedTableData = tableData.map((data) => {
      if (data.id === rowData.id) {
        return { ...data, duplicate_count: e.target.value === 0 ? "-" : e.target.value };
      }
      return data;
    });
    console.log(updatedTableData, "uuuuuuuuuu")
    setTableData(updatedTableData); // Set the updated data

    setIsDuplicateCountChanged(true);
  };

  const toggleRowSelection = (rowId) => {
    setSelectedRows((prevSelected) => {
      if (prevSelected.includes(rowId)) {
        return prevSelected.filter((id) => id !== rowId); // Remove from selection
      } else {
        return [...prevSelected, rowId]; // Add to selection
      }
    });
  };
  return (
    <div
      style={{
        padding: '0px 0px'
      }}>
      <Card
        elevation={0}
        sx={{
          p: "0.5rem",
          borderRadius: "12px",
          marginX: "1%",
        }}
      >
        <div id="frequency_selector" style={{ paddingRight: "10px" }}>
          <Grid
            container
            className="mb-2"
            alignItems="center"
            justifyContent="space-between "
            spacing={1}
          >
            <Grid item marginLeft={"0.7%"}>
              {mergedSelection && (
                <>
                  <Typography sx={{ textAlign: "center", fontWeight: "550" }}>
                    {mergedSelection}
                  </Typography>
                  {tableData && tableData.length > 0 && (
                    <Typography sx={{ color: "#2196f3", fontSize: "14px" }}>
                      Total Records: {tableData.length}
                    </Typography>
                  )}
                </>
              )}
            </Grid>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Grid item>
                <ToggleButtonGroup
                  color="primary"
                  size="small"
                  value={frequency}
                  exclusive
                  onChange={handleFrequencyChange}
                  aria-label="frequency"
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",

                  }}
                >
                  {["daily", "weekly", "monthly", "quarterly", "Ad-Hoc"].map(
                    (freq) => (
                      <ToggleButton
                        key={freq}
                        value={freq}
                        sx={{
                          textTransform: "uppercase",
                          color: "#EAEAE",
                          fontWeight: "400",
                          "&.Mui-selected": {
                            color: "white",
                            fontWeight: "500",
                            backgroundColor: "#0576FC",
                            "&:hover": {
                              backgroundColor: "#0576FC",
                            },
                          },
                        }}
                      >
                        {freq}
                      </ToggleButton>
                    )
                  )}
                </ToggleButtonGroup>
              </Grid>

              <Grid item>
                <FormControl
                  variant="outlined"
                  sx={{ minWidth: 160, marginLeft: "8px" }}
                >
                  <Select
                    size="small"
                    value={selectedFeed || ""}
                    onChange={handleSourceChange}
                    displayEmpty
                  >
                    <MenuItem value="">Select Source</MenuItem>
                    {sources.map((source) => (
                      <MenuItem key={source} value={source}>
                        {source.replaceAll("_", " ")}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </div>
          </Grid>
        </div>
      </Card>
      <Card
        sx={{
          border: "none",
          boxShadow: "none",
          marginTop: "14px",
          marginX: "1%",
          borderRadius: "16px",
          padding: "10px",

        }}>
        <div>
          {console.log(tableData, "table dtata")
          }
          <DataTable
            value={tableData}
            editable
            sortable
            paginator
            rows={10}
            style={{ paddingTop: "10px" }}
            selectionMode="checkbox"
            resizableColumns
            selection={selectedRecord}
            dataKey="id"
            onSelectionChange={(e) => {
              setSelectedRecord(e.value);
            }}
            // header={dataTableHeader}
            className={
              areFiltersEnabled
                ? "filters-enabled custom-data-table px-3"
                : " filters-disabled custom-data-table px-3"
            }
            paginatorLeft={<span style={{ fontSize: '14px' }}>Total Records: {tableData.length}</span>}

            emptyMessage={
              <div
                style={{
                  textAlign: "center",
                  width: "100%",
                  height: "1.5rem",
                  marginTop: "0.5rem",
                }}
              >
                Please Select a Source
              </div>
            }
          >
            <Column selectionMode={tableData?.length > 0 && "multiple"} />
            <Column
              field="source_name"
              header="Source Name"
              filter

              filterMenuStyle={{ textAlign: "center" }}
              filterPlaceholder="Search by name"
            />
            <Column
              field="source_table"
              header="Source Table"
              filter
              style={{
                maxWidth: "100px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              body={(rowData) => (
                <span
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <Tooltip title={rowData?.source_table}>
                    {rowData?.source_table}
                  </Tooltip>
                </span>
              )}
              filterMenuStyle={{ textAlign: "center" }}
              filterPlaceholder="Search by Source Table"
            />
            <Column
              field="frequency"
              header="Frequency"
              filter
              body={statusBodyTemplate}
              style={{ textTransform: "uppercase" }}
              headerStyle={{ textTransform: "none", paddingLeft: "20px" }}
              filterMenuStyle={{ textAlign: "center" }}
              filterPlaceholder="Search by frequency"

            />
            <Column
              field="expected_time"
              header="Expected By"
              filter
              style={{
                maxWidth: "130px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              body={(rowData) => (
                <span
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <Tooltip title={rowData?.expected_time}>
                    {rowData?.expected_time}
                  </Tooltip>
                </span>
              )}
              filterMenuStyle={{ textAlign: "center" }}
              filterPlaceholder="Search by Expected By"
            />

            <Column
              field="duplicate_count"
              header="Duplicate Count"
              filter
              filterPlaceholder="Search by Duplicate Count"
              body={(rowData) => {
                // Check if the current row is selected
                const isSelected = selectedRecord.some(record => record.id === rowData.id);
                setDuplicateselect(isSelected);
                return (
                  <span
                    style={{
                      color: rowData.duplicate_count == 0 ? "black" : "red",
                      cursor: isSelected ? "text" : "pointer", // Change cursor to indicate editability
                    }}
                  >
                    {isSelected ? (
                      <InputText
                        style={{
                          width: "100px", textAlign: "start !important", marginLeft: "-40px"
                        }}
                        min={"0"}
                        type="number"
                        value={rowData.duplicate_count}
                        onChange={(e) => handleNoDuplicateChange(e, rowData)}
                        onKeyDown={(e) => {

                          if (
                            e.key === 'e' ||
                            e.key === 'E' ||
                            e.key === '+' ||
                            e.key === '-' ||
                            e.key === '.'
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    ) : <span style={{ marginRight: "40px" }}>{(rowData.duplicate_count == 0 ? '-' : rowData.duplicate_count
                    )}</span>}
                  </span>
                );
              }}
              headerStyle={{}}
              style={{ textAlign: "center" }}
            />



            <Column
              field="arrival_date"
              header="Arrival Date"
              filter
              filterMenuStyle={{ textAlign: "center" }}
              filterPlaceholder="Search by Arrival Date"
              body={(rowData) => {
                const arrivalDate = new Date(rowData.arrival_date);
                const day = String(arrivalDate.getDate()).padStart(2, '0'); // Get day and ensure 2 digits
                const month = String(arrivalDate.getMonth() + 1).padStart(2, '0'); // Get month and ensure 2 digits
                const year = arrivalDate.getFullYear(); // Get year
                return `${day}-${month}-${year}`; // Return formatted date as dd-mm-yyyy
              }}
            // headerStyle={{ textAlign: "center" }}
            // style={{ textAlign: 'center' }}
            />


            <Column
              field="arrival_time"
              header="Arrival Time"
              filter


              filterMenuStyle={{ textAlign: "center" }}
              filterPlaceholder="Search by Arrival Time"
              body={(rowData) =>
                rowData.arrival_time
              }
            />
            <Column
              field="data_arrived"
              header="Arrival Status"
              body={(rowData) =>
                <span
                  style={{
                    color: rowData.data_arrived === "ARRIVED LATE" ? "red" : "",
                  }}
                >
                  {rowData?.data_arrived}
                </span>
              }

              filter
              filterMenuStyle={{ minWidth: "12rem", textAlign: "center" }}
              filterPlaceholder="Search by Arrival Status"
            />
            {/* <Column
              field="validated_by"
              header="Validated By"
              filter
              body={(rowData) => rowData.validated_by}
              filterMenuStyle={{ minWidth: "8rem", textAlign: "center" }}
              filterPlaceholder="Search by validated By"
            /> */}
          </DataTable>
        </div>
      </Card>
      {selectedFeed && (
        <div
          className="selected-users"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "sticky",
            // marginTop:"24rem",
            bottom: "2rem",
            // marginBottom: "5%",
            // marginTop:"auto"

            // marginX: "auto",
          }}
        >

          <>
            <div className="action-bar">
              <div className="selection-summary">
                {/* {selectedRecord && selectedRecord.length} */}
                {/* <span className="light-text" style={{ padding: "2px" }}>
                  {" "}
                  of{" "}
                </span> */}

                <span className="light-text">
                  {tableData && tableData.length > 0 && (
                    <>
                      {selectedRecord && selectedRecord.length > 0 && (
                        <span className="light-text" style={{ padding: "2px" }}>
                          {selectedRecord.length} of {tableData.length}
                        </span>
                      )}{" "}
                      {selectedRecord && selectedRecord.length > 0
                        ? tableData.length > 1
                          ? " Records Selected"
                          : " Record Selected"
                        : null}
                    </>
                  )}
                </span>
              </div>

              <button onClick={exportExcel} className="action-button">
                Export
              </button>

              <button
                className="action-button"
                onClick={(e) => {
                  handleEdit(e); setEditElement({
                    data_arrived: "NOT ARRIVED",
                    arrival_time: null,
                    arrival_date: datesChecked?.[0]
                  });
                }}
                disabled={
                  selectedRecord &&
                  (selectedRecord.length > 1 || selectedRecord.length === 0)
                } // Disables if more than 1 user
              >
                Edit
              </button>

              <button
                className="action-button mx-2"
                onClick={() => {
                  handleBulkEdit();
                  setEditElement({
                    data_arrived: "NOT ARRIVED",
                    arrival_time: null,
                    arrival_date: datesChecked?.[0]
                  });
                }}
                disabled={
                  selectedRecord &&
                  (selectedRecord.length === 1 || selectedRecord.length === 0)
                } // Disables if exactly 1 user
              >
                Bulk Edit
              </button>
              <button
                className="action-button"
                style={{ color: "#fff" }}
                onClick={() => {

                  setOpenConfirmSave(true)
                }}
                disabled={
                  isEditingEnabled || saveState
                }
              >
                Save
              </button>
              {/* {!isEditingEnabled?(
                <button
                className="action-button mx-2"
                onClick={() =>{setIsEditingEnabled(!isEditingEnabled);
                  setSelectedRecord([])
                }}
              >
                Edit Duplicate Count
              </button>): */}
              {/* {isDuplicateCountChanged&&(<button
                className="action-button mx-2"
                onClick={() =>(setDuplicateselect(!duplicateselect))}
              >
                Save Duplicate Count
              </button>)} */}



              <button
                className="action-button mx-2"
                onClick={() => handleReset()}
                disabled={!disableReset} // Disables if more than 1 user
              >
                Reset
              </button>
            </div>
          </>

        </div>
      )}
      {/* {(selectedRecord.length > 0 || isRowEdited) && (
                <Box
                    sx={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        backgroundColor: 'white',
                        padding: '4px',
                        zIndex: 1000
                    }}
                >
                    <Grid container spacing={1} sx={{ justifyContent: 'center' }}>
                        {selectedRows.length > 1 && (
                            <>
                                <Grid item xs={12} sm={4} md={3}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Data Arrival Status</InputLabel>
                                        <Select
                                            value={dataArrivalStatus}
                                            onChange={handleDataArrivalStatusChange}
                                            size="small"
                                            sx={{ maxWidth: '70%' }}
                                        >
                                            <MenuItem value="NOT ARRIVED">Not Arrived</MenuItem>
                                            <MenuItem value="ARRIVED EARLY">Arrived Early</MenuItem>
                                            <MenuItem value="ARRIVED ON TIME">Arrived On Time</MenuItem>
                                            <MenuItem value="ARRIVED LATE">Arrived Late</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={4} md={3}>
                                    <TextField
                                        label="Data Arrival Time"
                                        type="time"
                                        value={dataArrivalTime}
                                        onChange={handleDataArrivalTimeChange}
                                        size="small"
                                        fullWidth
                                        sx={{ maxWidth: '70%' }}
                                    />
                                </Grid>
                            </>
                        )}
                        <Grid item xs={12} sm={4} md={3}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleSubmit}
                                disabled={!isSubmitEnabled}
                                fullWidth
                            >
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            )} */}
      <Modal
        open={openEdit}
        onClose={handleEdit}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              sx={{ color: "#333", padding: "30px 40px 0px 40px" }}
              component="h2"
            >
              Apply Edit
            </Typography>
          </div>
          <div style={{ padding: "0px 32px 32px 32px" }}>
            {( frequency!=="Ad-Hoc" && datesChecked) && (
              <><Typography
                className="mb-1"
                variant="body2"
                sx={{ fontWeight: "400", mt: 3 }}
              >
                Arrival Date
              </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    labelId="data-arrived-label"
                    name="arrival_date"
                    error={arrivalDateError}
                    // value={dataArrivalStatus}
                    value={editElement.arrival_date || datesChecked?.[0]}
                    onChange={handleArrivalDateChange}
                  >
                    {Object.entries(datesChecked).map(([key, value], index) => (
                      <MenuItem key={index} value={value}>
                        {value}
                      </MenuItem>
                    ))}



                  </Select>
                </FormControl>
                {helperArrivalText != "" && (
                  <p className="text-danger" style={{ fontSize: '14px' }}>{helperArrivalText}</p>
                )}</>)}

            <Typography
              className="mb-1"
              variant="body2"
              sx={{ fontWeight: "400", mt: 3 }}
            >
              Arrival Time
            </Typography>
            <TextField
              size="small"
              name="arrival_time"
              type="time"
              error={error}
              helperText={helperText}
              value={editElement?.arrival_time}
              onChange={handleDataArrivalTimeChange}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Typography
              className="mb-1"
              variant="body2"
              sx={{ fontWeight: "400", mt: 3 }}
            >
              Arrival Status
            </Typography>
            <FormControl fullWidth size="small">
              <Select
                defaultValue={editElement?.data_arrived}
                labelId="data-arrived-label"
                name="data_arrived"
                onChange={handleDataArrivalStatusChange}
              >
                <MenuItem value="NOT ARRIVED">NOT ARRIVED</MenuItem>
                <MenuItem value="ARRIVED EARLY">ARRIVED EARLY</MenuItem>
                <MenuItem value="ARRIVED ON TIME">ARRIVED ON TIME</MenuItem>
                <MenuItem value="ARRIVED LATE">ARRIVED LATE</MenuItem>
              </Select>
            </FormControl>
            {/* </Grid> */}

            <div className="save-button">
              <Button
                variant="contained"
                className="save-button mx-3"
                onClick={() => setOpenEdit(!openEdit)}
                endIcon={<MdCancel />}
                sx={{ mt: 3, background: "#fff", color: "grey" }}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                className="save-button"
                onClick={handleSubmit}
                endIcon={<SaveOutlinedIcon />}
                sx={{ mt: 3, background: "#0576FC" }}
              >
                Save
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={openBulkEdit}
        onClose={handleBulkEdit}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              sx={{ color: "#333", padding: "30px 40px 0px 40px" }}
              component="h2"
            >
              Apply Bulk Edit
            </Typography>
          </div>
          <div style={{ padding: "0px 32px 32px 32px" }}>

            {(frequency !== "Ad-Hoc" && datesChecked) && (
              <><Typography
                className="mb-1"
                variant="body2"
                sx={{ fontWeight: "400", mt: 3 }}
              >
                Arrival Date
              </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    labelId="data-arrived-label"
                    name="arrival_date"
                    error={arrivalDateError}
                    // value={dataArrivalStatus}
                    value={editElement.arrival_date}
                    onChange={handleArrivalDateChange}
                  >
                    {Object.entries(datesChecked).map(([key, value], index) => (
                      <MenuItem key={index} value={value}>
                        {value}
                      </MenuItem>
                    ))}



                  </Select>
                </FormControl>
                {helperArrivalText != "" && (
                  <p className="text-danger" style={{ fontSize: '14px' }}>{helperArrivalText}</p>
                )}
              </>
            )}
            {console.log(helperArrivalText, "helper text")
            }
            <Typography
              className="mb-1"
              variant="body2"
              sx={{ fontWeight: "400", mt: 3 }}
            >
              Arrival Time
            </Typography>
            <TextField
              name="arrival_time"
              type="time"
              size="small"
              error={error}
              helperText={helperText}
              // value={dataArrivalTime}
              onChange={handleDataArrivalTimeChange}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Typography
              className="mb-1"
              variant="body2"
              sx={{ fontWeight: "400", mt: 3 }}
            >
              Arrival Status
            </Typography>
            <FormControl fullWidth size="small">
              <Select
                labelId="data-arrived-label"
                name="data_arrived"
                defaultValue={"NOT ARRIVED"}
                // value={dataArrivalStatus}
                onChange={handleDataArrivalStatusChange}
              >
                <MenuItem value="NOT ARRIVED">NOT ARRIVED</MenuItem>
                <MenuItem value="ARRIVED EARLY">ARRIVED EARLY</MenuItem>
                <MenuItem value="ARRIVED ON TIME">ARRIVED ON TIME</MenuItem>
                <MenuItem value="ARRIVED LATE">ARRIVED LATE</MenuItem>
              </Select>
            </FormControl>
            {/* </Grid> */}

            <div className="save-button">
              <Button
                variant="contained"
                className="save-button mx-3"
                onClick={() => handleBulkEdit()}
                endIcon={<MdCancel />}
                sx={{ mt: 3, background: "#fff", color: "grey" }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="save-button"
                onClick={handleSubmit}
                endIcon={<SaveOutlinedIcon />}
                sx={{ mt: 3, background: "#0576FC" }}
              >
                Save
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={openConfirmSave}
        onClose={() => setOpenConfirmSave(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              sx={{ color: "#333", padding: "25px 25px 0px 25px" }}
              component="h2"
            >
              Are you sure you want to save {selectedFeed?.replaceAll("_", " ")}{" "}
              ?
            </Typography>
          </div>
          <div style={{ padding: "0px 32px 32px 32px" }}>
            <div className="d-flex justify-content-center">
              <Button
                variant="contained"
                className="save-button mx-3"
                onClick={() => setOpenConfirmSave(false)}
                endIcon={<MdCancel />}
                sx={{ mt: 3, background: "#fff", color: "grey" }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="save-button"
                onClick={() => onSubmit(tableData)}
                endIcon={<SaveOutlinedIcon />}
                disabled={saveState}
                sx={{ mt: 3, background: "#0576FC" }}
              >
                Save
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      <ToastContainer
        toastOptions={{
          style: {
            fontSize: "20px",
            padding: "16px",
            width: "350px",
          },
        }}
      />
    </div>
  );
}

export default DataFileStatus;